<template>
  <div class="build-website-container">
    <div class="page-container-title">自助开通</div>
    <div class="page-form-container">
      <div class="form-item">
        <el-form :model="form" :rules="rules" ref="dialogForm" label-width="86px" label-position="left" size="mini">
          <el-form-item label="版本选择"  prop="Level">
            <el-select v-model="form.Level" style="width: 100%;">
              <el-option v-for="(item, index) in vipList" :key="index" :label="item.Name" :value="item.Level"/>
            </el-select>
          </el-form-item>
          <el-form-item label="站点名称"  prop="SiteName">
            <el-input v-model="form.SiteName"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="18">
              <el-form-item label="域名选择" prop="url1">
                <el-input v-model="form.url1">
                  <el-button slot="append" @click="handleRandom">随机生成</el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="padding-left: 15px;">
              <el-form-item label-width="0" prop="url2">
                <el-select v-model="form.url2" style="width: 100%;">
                  <el-option v-for="(item, index) in urlList" :key="index" :label="item.MainUrl" :value="item.MainUrl"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="QQ"  prop="Qq">
            <el-input v-model="form.Qq"></el-input>
          </el-form-item>
          <el-form-item label="微信"  prop="Wx">
            <el-input v-model="form.Wx"></el-input>
          </el-form-item>
          <el-form-item label="网站Logo"  prop="Logo">
            <div class="img-item">
              <van-uploader name="Photo" :preview-image="false" :deletable="false" :after-read="handleUploadImg">
                <div v-if="form.Logo" class="img img-cover"><img :src="form.Logo" /></div>
                <div v-else class="add-img img-contain"><img src="../../assets/images/add-btn-icon.png" /></div>
              </van-uploader>
            </div>
          </el-form-item>
          <el-form-item label=" ">
            <el-button type="primary" :loading="submiting" @click="handleSubmit">立即开通</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: "ContentGdAddComponent",
  data() {
    return {
      vipList: [],
      urlList: [],
      form: {
        Level: '',
        url1: '',
        url2: '',
        SiteName: '',
        Qq: '',
        Wx: '',
        Logo: ''
      },
      rules: {
        Level: [
          {required: true, message: '请选择版本'}
        ],
        SiteName: [
          {required: true, message: '请输入站点名称'}
        ],
        url1: [
          {required: true, message: '请输入域名前缀'}
        ],
        url2: [
          {required: true, message: '请选择域名'}
        ],
      },
      submiting: false
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  mounted() {
    this.handleGetUrlList()
    this.handleGetVipList()
  },
  methods: {
    ...mapActions(['GetUserInfo']),
    handleRandom() {
      const strArr = 'abcdefghijklmnopqrstuvwxyz1234567890'.split('')
      const count = Math.round(Math.random() * 3) + 2
      let str = ''
      for (let index = 0; index < count; index++) {
        str += strArr[Math.round(Math.random() * (strArr.length - 1))]
      }
      this.form.url1 = str
    },
    async handleGetUrlList() {
      var res = await this.$API.urlList.post()
      if (res && res.info && res.info.length > 0) {
        this.urlList = res.info
      }
    },
    async handleGetVipList() {
      var res = await this.$API.vipMoney.post({
        Type: 2
      })
      if (res && res.length > 0) {
        this.vipList = res
      }
    },
    async handleUploadImg(file) {
      var res = await this.$API.upload.post(file[0])
      if (res.error == 0) {
        this.form.Logo = res.info
      } else {
        this.$toast(res.info)
      }
    },
    async handleSubmit() {
      if (this.submiting) {
        return
      }
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          const { form } = this
          const params = {
            ...form
          }
          params.Url = form.url1 + '.' + form.url2
          delete params.url1
          delete params.url2
          if (params.Qq) {
            params.Qq = JSON.stringify({ num: params.Qq, status: 1 })
          }
          if (params.Wx) {
            params.Wx = JSON.stringify({ code: params.Wx, num: '', status: 1 })
          }
          params.SiteName = params.SiteName.replace(/抖音/g, '音乐')
          params.SiteName = params.SiteName.replace(/DY/g, '音乐')
          params.SiteName = params.SiteName.replace(/dy dou/g, '音乐')
          params.SiteName = params.SiteName.replace(/快手/g, '手手')
          params.SiteName = params.SiteName.replace(/KS/g, '手手')
          params.SiteName = params.SiteName.replace(/ks/g, '手手')
          params.SiteName = params.SiteName.replace(/代刷/g, '乐园')
          params.SiteName = params.SiteName.replace(/业务/g, '乐园')
          params.SiteName = params.SiteName.replace(/水军/g, '乐园')
          params.SiteName = params.SiteName.replace(/粉丝/g, '乐园')
          params.SiteName = params.SiteName.replace(/涨粉/g, '乐园')
          params.SiteName = params.SiteName.replace(/点赞/g, '乐园')
          params.SiteName = params.SiteName.replace(/播放/g, '乐园')
          params.SiteName = params.SiteName.replace(/人气/g, '乐园')
          params.SiteName = params.SiteName.replace(/热门/g, '乐园')
          this.submiting = true
          var res = await this.$API.buySubstations.post(params)
          this.submiting = false
          if (res.error == 0) {
            this.GetUserInfo()
          }
          this.$dialog.alert({
            type: 'danger',
            className: 'pc-dialog',
            title: '提示',
            message: res.info,
            confirmButtonText: '确定',
          })
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.page-container-title {
  padding: 20px 0 14px;
  height: 25px;
  padding-left: 20px;
  position: relative;
  color: #5783fc;
  line-height: 25px;
  font-size: 18px;
  border-bottom: 1px solid #e5e5e5;
  &::after {
    content: '';
    position: absolute;
    width: 5px;
    height: 25px;
    border-radius: 3px;
    background-color: #5783fc;
    left: 0;
    top: 20px;
  }
}
.build-website-container {
  padding: 0 15px;
}
.form-item {
  margin-top: 18px;
  /deep/.van-uploader__wrapper {
    margin-left: 0;
  }
  .img-item {
    cursor: pointer;
    width: 80px;
    height: 80px;
    border: 1px solid #f8f8f8;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    .img {
      width: 80px;
      height: 80px;
    }
    .add-img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>